import React from 'react';
import {WeaLocaleProvider} from 'ecCom';
import {Calendar} from 'antd';
import {WeaTextarea} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import Header from './Common/header';
import './css/index';

export default class Content_video extends React.Component {
    render() {
        const {data = {}, config ={}, eid} = this.props;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header data={data} eid={eid}/>
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_${eid}`}>
                        <div className="ant-spin-nested-loading">
                            <div className="ant-spin-container">
                                <div id="video_play_576" style={{width: '100%'}}>
                                    <video src="/page/resource/userfile/image/elementPrew/wxdzfp.mp4" autoPlay="autoplay"
                                           controlsList="nodownload" controls style={{width: '100%'}}></video>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_video.js